import { t } from 'i18next'

import { FormGroup } from '~/components/unform/FormGroup'
import FileInput from '~/components/unform/Input/FileInput'
import { Label } from '~/components/unform/Label'

import * as S from './styles'

type FileUploadAreaProps = {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const FileUploadArea = ({ onChange }: FileUploadAreaProps) => {
  return (
    <FormGroup className="mb-4">
      <div className="d-flex">
        <Label
          text={t('rm:externalCampaignMetrics.form.file.label')}
          isRequired
        />
        <S.ExampleLinksWrapper>
          <a href="/PlaExemplo.xlsx" download="PlaExemplo.xlsx">
            PLAExemplo.xlsx
          </a>
          <a href="/PLAExemplo.csv" download="PLAExemplo.csv">
            PLAExemplo.csv
          </a>
        </S.ExampleLinksWrapper>
      </div>
      <S.Wrapper>
        <FileInput
          name="file"
          required
          accept=".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
          onChange={onChange}
        ></FileInput>
        <S.UploadContent>
          <S.RulesSection>
            <h5 className="rules-title">
              {t('rm:externalCampaignMetrics.form.rules.title')}
            </h5>
            <ul className="rules-list">
              <li>{t('rm:externalCampaignMetrics.form.rules.format')}</li>
              <li>{t('rm:externalCampaignMetrics.form.rules.delimiter')}</li>
              <li>{t('rm:externalCampaignMetrics.form.rules.date')}</li>
              <li>{t('rm:externalCampaignMetrics.form.rules.singleDay')}</li>
            </ul>
          </S.RulesSection>
        </S.UploadContent>
      </S.Wrapper>
    </FormGroup>
  )
}

export default FileUploadArea
